import BrandLayout from '@/layouts/BrandLayout.vue'
export default {
  path: '/',
  component: BrandLayout,
  redirect: '/brand/dashboard',
  children: [
    {
      path: '/brand/dashboard',
      name: 'brand-dashboard',
      component: () => import('@/views/Brand/NewDashboardView.vue'),
      meta: {
        name: 'brand-dashboard',
        requiresAuth: true,
        userType: 'brand',
        title: 'Brand Dashboard',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/new-dashboard',
      name: 'new-dashboard',
      component: () => import('@/views/Brand/NewDashboardView.vue'),
      meta: {
        name: 'brand-dashboard',
        requiresAuth: true,
        userType: 'brand',
        title: 'Brand Dashboard',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/build-your-campaign',
      name: 'build-your-campaign',
      component: () => import('@/views/Brand/BuildYourCampaign.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Build your campaign | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/build-your-mix-campaign',
      name: 'build-your-mix-campaign',
      component: () => import('@/views/Brand/BuildYourMixCampaign.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Build your campaign | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/create-campaign-settings',
      name: 'create-campaign-settings',
      component: () => import('@/views/Brand/CreateCampaignSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'campaign-settings | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/create-mix-campaign-settings',
      name: 'create-mix-campaign-settings',
      component: () => import('@/views/Brand/CreateMixCampaignSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'mix-campaign-settings | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/edit-campaign-settings/:campaignSettingId',
      name: 'edit-campaign-settings',
      component: () => import('@/views/Brand/EditCampaignSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'campaign-settings | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/edit-location-settings/:campaignSettingId',
      name: 'edit-location-settings',
      component: () => import('@/views/Brand/EditLocationSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'location-settings | Brand',
        breadcrumb: 'Login'
      }
    },
    // {
    //   path: '/brand/pickl-history',
    //   name: 'pickl-history',
    //   component: () => import('@/views/Brand/PicklHistory.vue'),
    //   meta: {
    //     requiresAuth: false,
    //     title: 'Pickl History | Brand',
    //     breadcrumb: 'Login'
    //   }
    // },
    {
      path: '/brand/geo-location-type',
      name: 'geo-location-type',
      component: () => import('@/views/Brand/GeoLocationType.vue'),
      meta: {
        requiresAuth: false,
        title: 'Geo location type | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/activity-incentives-type',
      name: 'activity-incentives-type',
      component: () => import('@/views/Brand/ActivityIncentivesType.vue'),
      meta: {
        requiresAuth: false,
        title: 'Activity incentives type | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/use-coupon-free-ticket',
      name: 'use-coupon-free-ticket',
      component: () => import('@/views/Brand/UseCouponOrFreeTicket.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Use coupon or free ticket | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/saved-campaign-settings',
      name: 'saved-campaign-settings',
      component: () => import('@/views/Brand/SavedCampaignSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Saved campaign settings | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:campaignSettingId/where-you-want-to-launch',
      name: 'where-you-want-to-launch',
      component: () => import('@/views/Brand/WhereYouWantToLaunch.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Where you want to launch | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:campaignSettingId/where-you-want-to-launch-mix',
      name: 'where-you-want-to-launch-mix',
      component: () => import('@/views/Brand/WhereYouWantToLaunchMix.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Where you want to launch mix campaign | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/saved-location-settings',
      name: 'saved-location-settings',
      component: () => import('@/views/Brand/SavedLocationSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Saved location settings | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:campaignSettingId/select-location-settings',
      name: 'select-location-settings',
      component: () => import('@/views/Brand/SelectLocationSettings.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Select location setting | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:campaignSettingId/location-settings',
      name: 'any-user-location',
      component: () => import('@/views/Brand/AnyUserLocation.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Any user location | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:campaignSettingId/mix-location-settings',
      name: 'any-user-mix-location',
      component: () => import('@/views/Brand/AnyUserLocationMix.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Any user mix location | Brand',
        breadcrumb: 'Login'
      }
    },
    {
    path: '/brand/:campaignSettingId/edit-location-settings',
    name: 'edit-location-settings',
    component: () => import('@/views/Brand/EditLocationSettings.vue'),
    meta: {
      requiresAuth: true,
      userType: 'brand',
      title: 'Edit Locatino Settings | Brand',
      breadcrumb: 'Login'
    }
  },
    {
      path: '/brand/:picklCampaignSettingId/choose-activity',
      name: 'choose-activiy',
      component: () => import('@/views/Brand/ChooseActivity.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Choose Activity | Brand',
        breadcrumb: 'Login'
      }
    },
     {
      path: '/brand/:picklCampaignSettingId/choose-mix-activity',
      name: 'choose-mix-activity',
      component: () => import('@/views/Brand/ChooseMixActivity.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Choose Mix Activity | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/sort-mix-activities',
      name: 'sort-mix-activities',
      component: () => import('@/views/Brand/SortMixActivities.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Sort Mix Activities | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/saved-activity',
      name: 'saved-activity',
      component: () => import('@/views/Brand/SavedActivity.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Saved Activity | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/activity-creation',
      name: 'activity-creation',
      component: () => import('@/views/Brand/ActivityCreation.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Activity Creation | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/edit-activity',
      name: 'edit-activity',
      component: () => import('@/views/Brand/EditActivity.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Edit Activity | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/products',
      name: 'brand-products',
      component: () => import('@/views/Brand/ProductsView.vue'),
      meta: {
        name: 'brand-products',
        requiresAuth: true,
        userType: 'brand',
        title: 'Product Management',
        breadcrumb: 'Products Management'
      }
    },
    {
      path: '/brand/profile',
      name: 'brand-profile',
      component: () => import('@/views/Brand/Profile.vue'),
      meta: {
        name: 'brand-profile',
        requiresAuth: true,
        userType: 'brand',
        title: 'View Profile',
        breadcrumb: 'Profile'
      }
    },
    {
      path: '/brand/details',
      name: 'brand-details',
      component: () => import('@/views/Brand/Details.vue'),
      meta: {
        name: 'brand-details',
        requiresAuth: true,
        userType: 'brand',
        title: 'Brand Details',
        breadcrumb: 'Brand Details'
      }
    },
    {
      path: '/brand/data-analysis',
      name: 'brand-data-analysis',
      component: () => import('@/views/Brand/DataAnalysis.vue'),
      meta: {
        name: 'brand-data-analysis', 
        requiresAuth: true,
        userType: 'brand',
        title: 'Data Analysis',
        breadcrumb: 'Data Analysis'
      }
    },
    {
      path: '/brand/image-gallery',
      name: 'brand-image-gallery',
      component: () => import('@/views/Brand/ImageGallery.vue'),
      meta: {
        name: 'brand-image-gallery', 
        requiresAuth: true,
        userType: 'brand',
        title: 'Image Gallery',
        breadcrumb: 'Image Gallery'
      }
    },
    {
      path: '/brand/campaigns-data',
      name: 'brand-campaigns-data',
      component: () => import('@/views/Brand/CampaignsData.vue'),
      meta: {
        name: 'brand-campaigns-data', 
        requiresAuth: true,
        userType: 'brand',
        title: 'Campaigns Data',
        breadcrumb: 'Campaigns Data'
      }
    },
    {
      path: '/brand/offers',
      name: 'brand-offers',
      component: () => import('@/views/Brand/Offers.vue'),
      meta: {
        name: 'brand-offers',
        requiresAuth: true,
        userType: 'brand',
        title: 'Offers',
        breadcrumb: 'Offers'
      }
    },
    {
      path: '/brand/media',
      name: 'brand-media',
      component: () => import('@/views/Brand/MediaView.vue'),
      meta: {
        name: 'brand-media',
        requiresAuth: true,
        userType: 'brand',
        title: 'Media Management',
        breadcrumb: 'Media Management'
      }
    },
    {
      path: '/brand/tutorial-videos',
      name: 'brand-tutorials',
      component: () => import('@/views/Brand/TutorialVideos.vue'),
      meta: {
        name: 'brand-tutorial-videos',
        requiresAuth: true,
        userType: 'brand',
        title: 'Video Tutorials',
        breadcrumb: 'Video Tutorials'
      }
    },
    {
      path: '/brand/insights',
      name: 'brand-insights',
      component: () => import('@/views/Brand/SurveyView.vue'),
      meta: {
        name: 'brand-insights',
        requiresAuth: true,
        userType: 'brand',
        title: 'Insights Management',
        breadcrumb: 'Insights Management'
      }
    },
    {
      path: '/brand/non-geo-pickl-history',
      name: 'brand-non-geo-pickl-history',
      component: () => import('@/views/Brand/NonGeoPicklHistory.vue'),
      meta: {
        name: 'brand-non-geo-pickl-history',
        requiresAuth: true,
        userType: 'brand',
        title: 'Non Geo Pickl History',
        breadcrumb: 'Non Geo Pickl History'
      }
    },
    {
      path: '/brand/pickl-history',
      name: 'brand-pickl-history',
      component: () => import('@/views/Brand/PhysicalPicklHistory.vue'),
      meta: {
        name: 'brand-pickl-history',
        requiresAuth: true,
        userType: 'brand',
        title: 'Physical Pickl History',
        breadcrumb: 'Physical Pickl History'
      }
    },
    {
      path: '/brand/pickl-responses/:picklId',
      name: 'picklDetails',
      component: () => import('@/views/sAdmin/PicklResponses.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        name: 'pickl-responses',
        title: 'Alerts',
        breadcrumb: 'Alerts'
      }
    },
    {
      path: '/brand/pickls/:picklId',
      name: 'pickllist',
      component: () => import('@/views/sAdmin/PicklDetails.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        name: 'pickls',
        title: 'Alerts',
        breadcrumb: 'Alerts'
      }
    },
    {
      path: '/brand/coupons',
      name: 'brand-coupons',
      component: () => import('@/views/Brand/Coupons.vue'),
      meta: {
        name: 'brand-coupons',
        requiresAuth: true,
        userType: 'brand',
        title: 'Coupons',
        breadcrumb: 'Coupons'
      }
    },
    {
      path: '/brand/insight/create',
      name: 'brand-survey-create',
      component: () => import('@/views/Brand/CreateSurvey.vue'),
      meta: {
        name: 'brand-survey-create',
        requiresAuth: true,
        userType: 'brand',
        title: 'Create Insight',
        breadcrumb: 'Create Insight'
      }
    },
     {
      path: '/brand/coupons/create',
      name: 'brand-coupon-create',
      component: () => import('@/views/Brand/CreateCoupon.vue'),
      meta: {
        name: 'brand-coupon-create',
        requiresAuth: true,
        userType: 'brand',
        title: 'Create Coupon',
        breadcrumb: 'Create Coupon'
      }
    },
    {
      path: '/brand/insight/:surveyId/edit',
      name: 'brand-survey-edit',
      component: () => import('@/views/Brand/EditSurvey.vue'),
      meta: {
        name: 'brand-survey-edit',
        requiresAuth: true,
        userType: 'brand',
        title: 'Edit Insight',
        breadcrumb: 'Edit Insight'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/create-questions',
      name: 'create-questions',
      component: () => import('@/views/Brand/QuestionCreation.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Question | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/question/:surveyId/edit',
      name: 'edit-questions',
      component: () => import('@/views/Brand/QuestionUpdate.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Question | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/action-links',
      name: 'action-links',
      component: () => import('@/views/Brand/ActionLinks.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Action Links | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/any-physical-location-activity',
      name: 'any-physical-location-activity',
      component: () => import('@/views/Brand/AnyPhysicalLocationActivity.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Any Physical Location Activity | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/do-anywhere-insights',
      name: 'do-anywhere-insights',
      component: () => import('@/views/Brand/DoAnywhereInsights.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Do Any Where Insights | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/choose-audience',
      name: 'new-audience',
      component: () => import('@/views/Brand/NewAudience.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'New Audience | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/edit-media',
      name: 'edit-media',
      component: () => import('@/views/Brand/EditMedia.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Edit Media | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/upload-audience-list/:type',
      name: 'upload-audience-list',
      component: () => import('@/views/Brand/UploadAudienceList.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Upload Audience List | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/manage-campaign',
      name: 'manage-campaign',
      component: () => import('@/views/Brand/ManageCampaign.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Manage Campaign | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/ready-to-launch',
      name: 'ready-to-launch',
      component: () => import('@/views/Brand/ReadyToLaunch.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Ready to launch | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/campaign-view',
      name: 'campaign-view',
      component: () => import('@/views/Brand/CampaignView.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Campaign View | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/audience-overview',
      name: 'audience-overview',
      component: () => import('@/views/Brand/AudienceOverview.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Audience Overview | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/notes-from-reviewer',
      name: 'notes-from-reviewer',
      component: () => import('@/views/Brand/NotesFromReviewer.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Notes From Reviewer | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/quick-edit-campaign',
      name: 'quick-edit-campaign',
      component: () => import('@/views/Brand/QuickEditCampaign.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Quick Edit Campaign | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/:picklCampaignSettingId/edit-unlock-code',
      name: 'edit-unlock-code',
      component: () => import('@/views/Brand/EditUnlockCode.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Edit Unlock Code | Brand',
        breadcrumb: 'Login'
      }
    },


    
  ]
}
